import type { User } from 'types/user';

export const mockUserDetail: User = {
    id: '1883',
    name: 'Trâm Phan',
    firstName: 'Trâm',
    lastName: 'Phan',
    email: 'tram.phan@example.com',
    phonenumber: '+84 912 345 678',
    jobTitle: 'Trader · Premium',
    KYC: false,
    country: 'Việt Nam',
    city: 'Hồ Chí Minh',
    address: '123 Nguyễn Huệ, Quận 1',
    postalCode: '700000',
    dateOfBirth: '15/03/1992',
    gender: 'Nữ',
    avatar_url: '',
    isActive: true,
    status: 'Active',
    accountType: 'pre',
    lastLogin: '20/04/2026 21:44',
    createAt: '12/01/2024',
    updateAt: '20/04/2026',
    balance: 25400,
};

export interface UserStats {
    balance: string;
    totalTrades: number;
    openOrders: number;
    deposited: string;
    withdrawn: string;
    pnl: string;
}

export const mockUserStats: UserStats = {
    balance: '$25,400',
    totalTrades: 156,
    openOrders: 3,
    deposited: '$50,000',
    withdrawn: '$24,600',
    pnl: '+$1,250',
};

export interface UpdateEvent {
    id: string;
    actor: string;
    actorInitial: string;
    actorColor: string;
    action: string;
    target?: string;
    time: string;
}

export const mockUpdateHistory: UpdateEvent[] = [
    { id: '1', actor: 'Admin', actorInitial: 'A', actorColor: '#1677ff', action: 'đã cập nhật thông tin tài khoản', target: 'Trâm Phan', time: '20/04/2026 21:44' },
    { id: '2', actor: 'Trâm Phan', actorInitial: 'T', actorColor: '#16a34a', action: 'đã xác thực email thành công', time: '18/04/2026 09:12' },
    { id: '3', actor: 'System', actorInitial: 'S', actorColor: '#7c3aed', action: 'tự động nâng cấp lên gói Premium', time: '01/03/2026 00:00' },
    { id: '4', actor: 'Admin', actorInitial: 'A', actorColor: '#1677ff', action: 'tạo tài khoản cho', target: 'Trâm Phan', time: '12/01/2024 10:30' },
];

export interface LoginEvent {
    id: string;
    device: string;
    location: string;
    browser: string;
    time: string;
    status: 'success' | 'failed';
    isMobile: boolean;
}

export const mockLoginEvents: LoginEvent[] = [
    { id: '1', device: 'iPhone 15 Pro · iOS 17.4', location: 'Hà Nội, VN · 113.161.92.14', browser: 'Safari', time: '20/04/2026 21:44', status: 'success', isMobile: true },
    { id: '2', device: 'MacBook Air · macOS 14', location: 'Hà Nội, VN · 113.161.92.14', browser: 'Chrome 124', time: '20/04/2026 18:02', status: 'success', isMobile: false },
    { id: '3', device: 'MacBook Air · macOS 14', location: 'Hà Nội, VN · 14.177.44.82', browser: 'Chrome 124', time: '19/04/2026 20:11', status: 'success', isMobile: false },
    { id: '4', device: 'Unknown Android', location: 'Hải Phòng, VN · 103.199.74.201', browser: 'Chrome Mobile', time: '18/04/2026 22:33', status: 'failed', isMobile: true },
    { id: '5', device: 'MacBook Air · macOS 14', location: 'Hà Nội, VN · 14.177.44.82', browser: 'Chrome 124', time: '17/04/2026 09:15', status: 'success', isMobile: false },
];
